export const dispatchLoaderEvent = ({ showLoader }: { showLoader: boolean }) => {
  const customEvent = new CustomEvent('sdk-payments-loader-message', { detail: showLoader })
  document.dispatchEvent(customEvent)
}
